'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('disapprovalreasonEditCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, MessageService, model, DisapprovalReason) {
	var vm = this;

	var $translate = $filter('translate');

	vm.model = model;

	angular.extend($scope.$parent.vm, {
		title: 'disapprovalReasons.settings.title',
		insertUrl: null
	});

	$rootScope.laddaLoading = false;

	vm.save = function () {
		$rootScope.laddaLoading = true;


		if (!vm.model.disapprovalReasonId) {
			DisapprovalReason.insert(vm.model, function () {
				$state.go('main.disapprovalreason');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		} else {
			DisapprovalReason.update(vm.model, function () {
				$state.go('main.disapprovalreason');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		}
	}
});